export default {
  feedback: {
    usage_threshold: 'El importe mínimo del carrito para esta promo es (sin gastos de envío)',
    promo_code_added: 'Código promocional aplicado',
    promo_code_removed: 'Código promocional {{code}} eliminado',
  },
};
